'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _AbstractElement = require('./AbstractElement');

var _AbstractElement2 = _interopRequireDefault(_AbstractElement);

var _TextElementConstants = require('./TextElementConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getClasses = function getClasses(className, disabled, use, weight) {
  return (0, _classNames2.default)(className, disabled ? 'is--text--disabled' : {
    'is--text--regular': weight === _TextElementConstants.WEIGHTS.regular,
    'is--text--medium': weight === _TextElementConstants.WEIGHTS.medium,
    'is--text--demibold': weight === _TextElementConstants.WEIGHTS.demi,
    'is--text--bold': weight === _TextElementConstants.WEIGHTS.bold,
    'is--text--error': use === _TextElementConstants.USES.error,
    'is--text--help': use === _TextElementConstants.USES.help,
    'is--text--success': use === _TextElementConstants.USES.success
  });
};

function AbstractTextElement(props) {
  var className = props.className,
      disabled = props.disabled,
      use = props.use,
      weight = props.weight,
      rest = _objectWithoutProperties(props, ['className', 'disabled', 'use', 'weight']);

  return _react2.default.createElement(_AbstractElement2.default, _extends({}, rest, {
    className: getClasses(className, disabled, use, weight)
  }));
}

AbstractTextElement.propTypes = _extends({}, _AbstractElement2.default.propTypes, {
  use: _react.PropTypes.oneOf(Object.keys(_TextElementConstants.USES)),
  weight: _react.PropTypes.oneOf(Object.keys(_TextElementConstants.WEIGHTS))
});

AbstractTextElement.defaultProps = _AbstractElement2.default.defaultProps;

AbstractTextElement.displayName = 'AbstractTextElement';

exports.default = AbstractTextElement;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/elements/AbstractTextElement.js
// module id = 244
// module chunks = 3 4 5